import styled from 'styled-components';
import { BaseContainer } from '../../../styles/Container';
import media from '../../../styles/media';

export const TechnologyPageWrapper = styled(BaseContainer)`
  position: relative;
  padding: 176px 12px 60px 12px;
  flex-direction: column;
  max-width: 100%;

  ${media('large')} {
    max-width: 50%;
  }
  ul {
    padding-left: 18px;
  }
  > div:first-child {
    > div {
      display: flex;
      align-items: center;
      h1,
      img {
        display: inline-block;
        width: 70px;
        height: 70px;
        object-fit: contain;
      }
      h1 {
        margin-right: 42px;
        flex: 1;
      }
    }
  }
  > div:nth-child(2) {
    h1,
    h2 {
      margin-top: 8px;
    }
  }
  *:not(h1):not(h2) {
    font-weight: 400;
  }
  span {
    color: ${(props) => props.theme.colors.blue};
    position: absolute;
    top: 56px;
    left: 12px;
    cursor: pointer;
    max-width: 100%;

    :hover {
      color: ${(props) => props.theme.colors.darkBlue};
    }
  }
`;
